import type { RouteConfig } from 'vue-router';

/**
 * 积分系统
 */
export default [
  /**
   * 积分签到
   */
  {
    path: '/points/sign-in',
    meta: {
      title: '签到赚积分',
      customNavBar: true,
      showFooter: false,
      excludeTracking: true,
    },
    component: () => import('@/views/points/sign-in/index.vue'),
  },
  /**
   * 积分签到详情
   */
  {
    path: '/points/sign-in/detail',
    meta: {
      title: '积分明细',
      customNavBar: true,
      background: '#F8F9FF',
      showFooter: false,
    },
    component: () => import('@/views/points/sign-in/detail.vue'),
  },
  /**
   * 成就中心
   */
  {
    path: '/points/sign-in/achievement-center',
    meta: {
      title: '成就中心',
      customNavBar: true,
      background: '#F8F9FF',
      showFooter: false,
    },
    component: () => import('@/views/points/sign-in/achievement-center.vue'),
  },
  /**
   * 卡券兑换
   */
  {
    path: '/points/sign-in/exchange',
    meta: {
      title: '卡券兑换',
      customNavBar: true,
      background: '#F8F9FF',
    },
    component: () => import('@/views/points/sign-in/exchange.vue'),
  },
  /**
   * 积分签到提额结果
   */
  {
    path: '/points/assessment/result',
    meta: {
      title: '签到提额',
      showFooter: false,
      background: '#fff',
    },
    component: () => import('@/views/points/assessment-result.vue'),
  },
] as RouteConfig[];
